﻿import actual from 'jquery.actual';

$(window).on('load', function () {
    if ($('.wtb-page').length > 0) {
        GetMap();
    }
});

$(function () {
    Modernizr.on('webp', function (result) {
        $('[data-bgimage-webp]').each(function () {
            $(this).css('background-image', 'url("' + (result ? $(this).data('bgimage-webp') : $(this).data('bgimage')) + '")');
        });
    });

    Modernizr.on('webp.animation', function (result) {
        $('[data-bgimage-webp-animated]').each(function () {
            $(this).css('background-image', 'url("' + (result ? $(this).data('bgimage-webp-animated') : $(this).data('bgimage')) + '")');
        });
    });

    //$('.add-to-basket-product-card').on('click', function () {
    //    //$(this).prop('disabled', true).val($(this).data('adding'));
    //    console.log('working');
    //});

    window.dataLayer = window.dataLayer || [];
    if ($('.product-page').length > 0) {
        //console.log('product page');

        dataLayer.push({
            'event': 'productView',
            'pageType': 'confirmation',
            'pageCountry': $('.product-page').data('locale'), // the language-country combination for the page seen
            'ecommerce': {
                'currencyCode': $('.product-page').data('currency'),
                'detail': {
                    'products': [{
                        'name': $('.product-page').data('productname'),
                        'id': $('.product-page').data('sku'),
                        'category': $('.product-page').data('section')
                    }]
                }
            }
        });
    }

    if ($('.variant-page').length > 0) {
        dataLayer.push({
            'event': 'productView',
            'pageType': 'confirmation',
            'pageCountry': $('.variant-page').data('locale'), // the language-country combination for the page seen
            'ecommerce': {
                'currencyCode': $('.variant-page').data('currency'),
                'detail': {
                    'products': [{
                        'name': $('.variant-page').data('productname'),
                        'category': $('.variant-page').data('section'),
                        'variant': $('.variant-page').data('variantid')
                    }]
                }
            }
        });
    }

    if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
        //do nothing
    } else {
        var aspectRatioArray = [];
        $('.widget-image').each(function () {
            var aspectRatio = $(this).data('aspect-ratio');
            if ($.inArray(aspectRatio, aspectRatioArray) < 0) {
                aspectRatioArray.push(aspectRatio);
            }
        });

        if (aspectRatioArray.length > 0) {
            var style = $('<style>');
            $.each(aspectRatioArray, function (index, value) {
                style.append('.widget-image[data-aspect-ratio="' + value + '"]::before { padding-top: ' + value * 100 + '%; }\n');
            });
            $('head').append(style);
        }
    }

    if ($('.g-recaptcha').length > 0) {
        $('.g-recaptcha').parents('form').on('submit', function () {
            if (validateRecaptcha() && $(this).valid()) {
                //$('.first-optin-form').hide();
                //$('.loading-area').fadeIn();
                //$('.pleaseSayYouAreNotARobot').hide();
            } else {
                $('.pleaseSayYouAreNotARobot').removeClass('d-none');
                return false;
            }
        });
    }

    $('.PostNewsletterSignUp').on('click', function () {
        if ($('.PostNewsletterSignUp:checked').length > 0) {
            $('.address-form-area').removeClass('d-none');
        } else {
            $('.address-form-area').addClass('d-none');
        }
    });

    //Make header dropdowns (account, mini-cart) work on hover
    $('body').on('mouseover mouseout', 'header .dropdown', function () {
        var dropdown = $(this);
        var menu = $('.dropdown-menu', dropdown);
        dropdown[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
        menu[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
    });

    //Disable click event on header dropdowns
    $('body').on('click', 'header [data-toggle="dropdown"]', function () {
        return false;
    });

    //Make sticky mini-cart behave in the same way
    $('body').on('mouseover mouseout', '.mini-cart-area--sticky .mini-cart, .byoCurrentContentSlots-area--sticky .byoCurrentContentSlots', function () {
        var cart = $(this);
        cart[cart.is(':hover') ? 'addClass' : 'removeClass']('show');
    });

    $('.lazy').Lazy();

    if ($('.list-building-modal').length > 0) {
        $('.list-building-modal').modal('show');

        $('.list-building-modal').on('hide.bs.modal', function (e) {
            // do something...
            //alert("sffds");
            $.post("/mv");
        });

    }

    $(window).scroll(function () {
        clearTimeout($.data(this, 'scrollTimer'));
        $.data(this, 'scrollTimer', setTimeout(function () {
            if ($(this).scrollTop() > 50) {
                $('.scrolltop:hidden').stop(true, true).fadeIn();
            } else {
                $('.scrolltop').stop(true, true).fadeOut();
            }
        }, 250));
    });

    $('.scroll').click(function () {
        //console.log($(".wrapper").offset().top);
        $('html, body').animate({ scrollTop: 0 }, '500');
        return false;
    });

    $('.SelectColoursAndBuy').click(function () {
        var offset = 50;
        if ($('.ss-header').is(':visible')) {
            offset = $('.ss-header').outerHeight() + 20;
        }
        $('html, body').animate({
            scrollTop: $('.select-color-and-buy').offset().top - offset
        }, 500);
    });

    $(".accept-cookie-law-btn").click(function () {
        $.post($(this).data('url'));
        $('.cookieLaw').fadeOut();
        $('.showBanner').text(0);
    });

    $(".address-list .links-area .edit-link").click(function () {
        $('#modal-' + $(this).data('id')).modal('show');
    });

    $(".address-list .links-area .delete-link").click(function () {
        $('#modal-delete-' + $(this).data('id')).modal('show');
    });

    $(".address-list .links-area input").click(function () {
        $(".links-area").each(function (index) {
            if ($(this).find('input:checked').length > 0) {
                $(this).find('.delete-link').prop('disabled', true);
            } else {
                $(this).find('.delete-link').prop('disabled', false);
            }
        });

        $.post("/myaccount/updatedefaultaddress", { id: $(this).data('id'), type: $(this).data('type') });

    });

    $(".my-addresses-page .add-address-button").click(function () {
        $('#modal-new-address').modal('show');
    });

    $(".wish-list-add").click(function () {
        //console.log($('.showBanner').text());
        if ($('.showBanner').text() == "1") {
            alert($('.showBanner').data('jstext'));
        } else {
            var actionType = 'add';
            if ($(this).find('i').hasClass('fa-heart-o')) {
                $(this).find('i').removeClass('fa-heart-o').addClass('fa-heart');
                $(this).attr('title', $(this).data('removefrom'));
            } else {
                $(this).find('i').removeClass('fa-heart').addClass('fa-heart-o');
                $(this).attr('title', $(this).data('addto'));
                actionType = 'remove';
            }

            window.dataLayer = window.dataLayer || [];
            if (actionType == 'add') {
                dataLayer.push({
                    'event': 'addToWishList',
                    'pageType': 'confirmation',
                    'pageCountry': $(this).data('locale'),
                    'ecommerce': {
                        'currencyCode': $(this).data('currency'),
                        'detail': {
                            'products': [{
                                'name': $(this).data('productname'),
                                'id': $(this).data('sku'),
                                'variant': $(this).data('variantid')
                            }]
                        }
                    }
                });

            } else {
                dataLayer.push({
                    'event': 'removeFromWishList',
                    'pageType': 'confirmation',
                    'pageCountry': $(this).data('locale'),
                    'ecommerce': {
                        'currencyCode': $(this).data('currency'),
                        'detail': {
                            'products': [{
                                'name': $(this).data('productname'),
                                'id': $(this).data('sku'),
                                'variant': $(this).data('variantid')
                            }]
                        }
                    }
                });
            }
            $.post("/wishlist/addremove", { action: actionType, sku: $(this).data('sku'), variantid: $(this).data('variantid') }, function (data) {
                if (data > 0) {
                    $('.top-nav-wish-list-link i').removeClass('fa-heart-o').addClass('fa-heart');
                    $('.ss-menu .wishlist i').removeClass('fa-heart-o').addClass('fa-heart');
                } else {
                    $('.top-nav-wish-list-link i').removeClass('fa-heart').addClass('fa-heart-o');
                    $('.ss-menu .wishlist i').removeClass('fa-heart').addClass('fa-heart-o');
                }
            });
        }
        return false;
    });

    $(".remove-from-wish-list-link").click(function () {
        if ($('.showBanner').text() == "1") {
            alert($('.showBanner').data('jstext'));
        } else {
            $.post("/wishlist/addremovebyguid", { guid: $(this).data('guid') }, function (data) {
                if (data > 0) {
                    $('.top-nav-wish-list-link i').removeClass('fa-heart-o').addClass('fa-heart');
                } else {
                    $('.top-nav-wish-list-link i').removeClass('fa-heart').addClass('fa-heart-o');
                }
                $('.wishlist-count').text(data);
            });
            $(this).parents('form').fadeOut(function () {
                if ($('.wish-list-item-area form:visible').length == 0) {
                    $('.wish-list-item-area').addClass('d-none');
                    $('.wish-list-no-data').removeClass('d-none');
                }
            });
        }
        return false;
    });


    $(".wish-list-comments").blur(function () {
        $.post("/wishlist/updatecomment", { guid: $(this).data('guid'), comment: $(this).val() }, function (data) {
            //if (data > 0) {
            //    $('.top-nav-wish-list-link i').removeClass('fa-heart-o').addClass('fa-heart');
            //} else {
            //    $('.top-nav-wish-list-link i').removeClass('fa-heart').addClass('fa-heart-o');
            //}
            //$('.wishlist-count').text(data);
        });
    });

    $(".wtb-search-form").submit(function () {
        //geocode();
        return false;
    });
    //$(".update-address-btn").click(function () {
    //    $('#modal-' + $(this).data('id')).find('form')
    //    $('#modal-' + $(this).data('id')).modal('hide');

    //});

    $(".sign-up-form").submit(function (evt) {
        evt.preventDefault();

        if ($('.terms-confirm:checked').length == 0) {
            $('.confirm-terms').fadeIn();
        } else {

            //var fileupload = $("#UploadedFile").get(0);
            //console.log(fileupload.file);
            var data = new FormData();

            // You can update the jquery selector to use a css class if you want
            $(".sign-up-form input").each(function (x, y) {
                if ($(y).attr("type") == 'checkbox') {
                    data.append($(y).attr("name"), $(y).prop('checked'));
                } else {
                    data.append($(y).attr("name"), $(y).val());
                }
            });

            $.ajax({
                type: "post",
                url: $(".sign-up-form").attr('action'),
                contentType: false,
                processData: false,
                data: data,
                success: function (message) {
                    //console.log(message);
                }
            });

            $(this).hide();
            $('.inktense-thanks-page').fadeIn();
        }

    });

    $(".inktense-prize-form").submit(function (evt) {
        evt.preventDefault();

        if ($('.terms-confirm:checked').length == 0) {
            $('.confirm-terms').fadeIn();
        } else {

            //var fileupload = $("#UploadedFile").get(0);
            //console.log(fileupload.file);
            var data = new FormData();
            data.append("File", $('#UploadedFile')[0].files[0]);

            // You can update the jquery selector to use a css class if you want
            $(".inktense-prize-form input").each(function (x, y) {
                if ($(y).attr("type") == 'checkbox') {
                    data.append($(y).attr("name"), $(y).prop('checked'));
                } else {
                    data.append($(y).attr("name"), $(y).val());
                }
            });

            $(".inktense-prize-form select").each(function (x, y) {
                data.append($(y).attr("name"), $(y).val());
            });

            $.ajax({
                type: "post",
                url: $(".inktense-prize-form").attr('action'),
                contentType: false,
                processData: false,
                data: data,
                success: function (message) {
                    //console.log(message);
                },
                error: function () {
                    alert("there was error uploading files!");
                }
            });

            $(this).hide();
            $('.inktense-thanks-page').fadeIn();
        }

    });

    $(".terms-link").click(function () {
        $('.terms-modal').modal('show');
    });

    $(".sent-to-area a").click(function () {
        if ($(this).find('.fa-caret-down:visible').length > 0) {
            $(this).siblings('.full-address').hide();
            $(this).find('.fa-caret-down').hide();
            $(this).find('.fa-caret-right').css('display', 'inline-block');
        } else {
            $(this).siblings('.full-address').show();
            $(this).find('.fa-caret-down').css('display', 'inline-block');
            $(this).find('.fa-caret-right').hide();
        }
    });

    $(".initial-add-form button").click(function () {
        //        <input type="hidden" value="@vp.GroupProdCode" name="sku" />
        //            <input type="hidden" value="@Model.Section.Locale" name="locale" />
        //            <input type="hidden" value="1" name="quantity" />
        //            <input type="hidden" value="@Model.Product.VariantID.Value" name="variantID" />
        ////  
        var theFormElement = $(this).parents('.initial-add-form');
        var theOtherFormElement = $(this).parents('.add-to-basket-area').find('.plus-minus-form');

        var Currency = theFormElement.find('input[name="currency"]').val();
        var Section = theFormElement.find('input[name="section"]').val();
        var Price = theFormElement.find('input[name="price"]').val();
        var ProductName = theFormElement.find('input[name="productname"]').val();

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'addToCart',
            'pageType': 'confirmation',
            'pageCountry': theFormElement.find('[name="locale"]').val(), // the language-country combination for the page seen
            'ecommerce': {
                'currencyCode': Currency,
                'add': {
                    'products': [{
                        'name': ProductName,
                        'id': theFormElement.find('[name="sku"]').val(),
                        'quantity': theFormElement.find('[name="quantity"]').val(),
                        'price': Price,
                        'category': Section,
                        'variant': theFormElement.find('[name="variantID"]').val()
                    }]
                }
            }
        });

        window.addEventListener('marketingCookiesAccepted', function (e) {
            if (typeof pintrk !== 'undefined') {
                pintrk('track', 'addtocart', {
                    value: Price,
                    order_quantity: theFormElement.find('[name="quantity"]').val(),
                    currency: Currency

                });
            }
        }, false);

        $.post("/product/addskutocart", { sku: theFormElement.find('[name="sku"]').val(), locale: theFormElement.find('[name="locale"]').val(), variantID: theFormElement.find('[name="variantID"]').val(), quantity: 1, __RequestVerificationToken: theFormElement.find('[name="__RequestVerificationToken"]').val() }, function (data) {
            //var data2 = { responseJSON: data };

            window.addToCartEnd({ responseJSON: data });

            theFormElement.addClass('hidden');
            theOtherFormElement.removeClass('hidden');
            $('.cart-url-link .badge').text(data.productQuantity);

        }, "json");

        return false;
    });

    $(".product-card-form button").click(function () {
        var TheClickedButton = $(this);
        TheClickedButton.prop('disabled', true).html('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i>' + TheClickedButton.data('adding'));

        var theFormElement = $(this).parents('.product-card-form');

        var Currency = theFormElement.find('input[name="currency"]').val();
        var Section = theFormElement.find('input[name="section"]').val();
        var Price = theFormElement.find('input[name="price"]').val();
        var ProductName = theFormElement.find('input[name="productname"]').val();

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'addToCartProductCard',
            'pageType': 'confirmation',
            'pageCountry': theFormElement.find('[name="locale"]').val(), // the language-country combination for the page seen
            'ecommerce': {
                'currencyCode': Currency,
                'add': {
                    'products': [{
                        'name': ProductName,
                        'id': theFormElement.find('[name="sku"]').val(),
                        'quantity': theFormElement.find('[name="quantity"]').val(),
                        'price': Price,
                        'category': Section,
                        'variant': theFormElement.find('[name="variantID"]').val()
                    }]
                }
            }
        });

        window.addEventListener('marketingCookiesAccepted', function (e) {
            if (typeof pintrk !== 'undefined') {
                pintrk('track', 'addtocart', {
                    value: Price,
                    order_quantity: theFormElement.find('[name="quantity"]').val(),
                    currency: Currency

                });
            }
        }, false);

        $.post("/product/addskutocart", { sku: theFormElement.find('[name="sku"]').val(), locale: theFormElement.find('[name="locale"]').val(), variantID: theFormElement.find('[name="variantID"]').val(), quantity: 1, __RequestVerificationToken: theFormElement.find('[name="__RequestVerificationToken"]').val() }, function (data) {
            //var data2 = { responseJSON: data };

            window.addToCartEnd({ responseJSON: data });

            $('.cart-url-link .badge').text(data.productQuantity);
            TheClickedButton.prop('disabled', false).html(TheClickedButton.data('add-to-cart'));

        }, "json");

        return false;
    });

    $(".plus-minus-form button").click(function () {
        var theFormElement = $(this).parents('.plus-minus-form');
        var theOtherFormElement = $(this).parents('.add-to-basket-area').find('.initial-add-form');
        var currentBasketLevel = parseInt(theFormElement.find('.current-basket-value').text());
        var savedBasketLevel = currentBasketLevel;
        if ($(this).data('type') == "minus") {
            currentBasketLevel--;
        } else {
            currentBasketLevel++;
        }
        theFormElement.find('.current-basket-value').text(currentBasketLevel);
        if ($(this).data('stock-level') <= currentBasketLevel) {
            $(this).prop('disabled', true);
        } else {
            theFormElement.find('button').prop('disabled', false);
            if (currentBasketLevel == 0) {
                theFormElement.addClass('hidden');
                theOtherFormElement.removeClass('hidden');
                theFormElement.find('.current-basket-value').text(1);
            }
        }

        var Currency = theFormElement.find('input[name="currency"]').val();
        var Section = theFormElement.find('input[name="section"]').val();
        var Price = theFormElement.find('input[name="price"]').val();
        var ProductName = theFormElement.find('input[name="productname"]').val();
        var QtyToUse = currentBasketLevel;

        if (savedBasketLevel < currentBasketLevel) {
            QtyToUse = currentBasketLevel - savedBasketLevel;
        } else {
            // need to do a remove from basket before adding

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'removeFromCart',
                'pageType': 'confirmation',
                'pageCountry': theFormElement.find('[name="locale"]').val(), // the language-country combination for the page seen
                'ecommerce': {
                    'currencyCode': Currency,
                    'remove': {
                        'products': [{
                            'name': ProductName,
                            'id': theFormElement.find('[name="sku"]').val(),
                            'quantity': savedBasketLevel,
                            'price': (Price * savedBasketLevel),
                            'category': Section,
                            'variant': theFormElement.find('[name="variantID"]').val()
                        }]
                    }
                }
            });
        }
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'addToCart',
            'pageType': 'confirmation',
            'pageCountry': theFormElement.find('[name="locale"]').val(), // the language-country combination for the page seen
            'ecommerce': {
                'currencyCode': Currency,
                'add': {
                    'products': [{
                        'name': ProductName,
                        'id': theFormElement.find('[name="sku"]').val(),
                        'quantity': QtyToUse,
                        'price': (Price * QtyToUse),
                        'category': Section,
                        'variant': theFormElement.find('[name="variantID"]').val()
                    }]
                }
            }
        });

        window.addEventListener('marketingCookiesAccepted', function (e) {
            if (typeof pintrk !== 'undefined') {
                pintrk('track', 'addtocart', {
                    value: Price * QtyToUse,
                    order_quantity: QtyToUse,
                    currency: Currency
                });
            }
        }, false);

        $.post("/product/addskutocart", { ReplaceQty: true, sku: theFormElement.find('[name="sku"]').val(), locale: theFormElement.find('[name="locale"]').val(), variantID: theFormElement.find('[name="variantID"]').val(), quantity: currentBasketLevel, __RequestVerificationToken: theFormElement.find('[name="__RequestVerificationToken"]').val() }, function (data) {
            window.addToCartEnd({ responseJSON: data });
            //theFormElement.addClass('hidden');
            //theOtherFormElement.removeClass('hidden');
        }, "json");

        return false;
    });

    $(".other-images a").click(function () {
        if ($(this).data('video-url') != null) {
            //alert("make a modal that goes to: " + $(this).data('video-url'));
            $('.examples-modal .modal-body img').hide();
            var video = $('<video />').addClass('video-js').addClass('vjs-default-skin'); //.addClass('vjs-16-9');
            video.prop('controls', true);
            video.prop('autoplay', true);
            video.attr('id', 'example-video');
            video.attr('width', '100%');
            //video.attr('poster', $(this).data('video-url'));

            video.attr('data-setup', '{"fluid": true}');
            var source = $('<source />').attr('src', $(this).data('video-url')).attr('type', 'video/mp4');
            video.append(source);
            $('.examples-modal .modal-body #example-video').remove();
            $('.examples-modal .modal-body').append(video);
            $('.examples-modal').modal({
                keyboard: false
            });
        } else {
            $('.main-product-image').attr('src', $(this).data('bigimage'));
            $(".other-images a img").removeClass('border');
            $(this).find('.main-other-image').addClass('border');
        }
    });

    $(".add-to-cart-button-variant").click(function () {
        $(this).parents('form').find("input[name='sku']").val($(this).data('sku'));
    });

    $(".initial-add-form button").click(function () {
        $(this).parents('form').addClass('hidden');
        $(this).parents('.add-to-basket-area').find('.plus-minus-form').removeClass('hidden');
    });

    $(".input-group-append").click(function () {
        //console.log('/' + $(".site-search-box").data('locale') + '/s/' + $(".site-search-box").val());
        window.location = '/' + $(this).siblings(".site-search-box").data('locale') + '/s/' + $(this).siblings(".site-search-box").val();
    });

    $(".top-level-section-item").hover(
        function () {
            $(this).find('a').first().addClass('active');
            if ($(this).find('.dropdown-mm').length > 0) {
                $(this).find('.dropdown-mm').show();
                $('.mm-overlay').show();
            }
        }, function () {
            $(this).find('a').first().removeClass('active');
            $(this).find('.dropdown-mm').hide();
            $('.mm-overlay').hide();
        }
    );

    $(".ss-search-link, .ss-search-overlay").click(function () {
        if ($('.ss-menu').is(':visible')) {
            $('.ss-menu-link').trigger('click');
        }

        if ($('.ss-search-area-wrapper').is(':visible')) {
            $('.ss-search-area').animate({
                height: 0
            }, 250, function () {
                $('.ss-search-area-wrapper').hide();
            });
            $('.ss-search-overlay').fadeOut(250, function () {
                $(this).hide();
            });
        } else {
            $('.ss-search-area-wrapper').show();
            $('.site-search-box').focus();
            $('.ss-search-area').animate({
                height: $('.ss-search-area').get(0).scrollHeight
            }, 250);
            $('.ss-search-overlay').fadeIn(250);
        }
        return false;
    });

    $(".show-more-shades-button").click(function () {
        $('.show-less-shades-button').removeClass('d-none').addClass('d-block');
        $(this).addClass('d-none').removeClass('d-block');
        $('.shades-available .shade-item').removeClass('d-none');
    });

    $(".show-less-shades-button").click(function () {
        $('.show-more-shades-button').removeClass('d-none').addClass('d-block');
        $(this).addClass('d-none').removeClass('d-block');
        $('.shades-available .shade-item.d-md-block').addClass('d-none');
    });

    $(".sitewide-search-form, .ss-sitewide-search-form").submit(function () {
        //console.log('/' + $(".site-search-box").data('locale') + '/s/' + $(".site-search-box").val());
        //console.log($('.autocomplete-suggestion.selected:visible').length);
        if ($('.autocomplete-suggestion.selected:visible').length > 0) {
            $('.autocomplete-suggestion.selected:visible').data('url');
        } else {
            window.location = '/' + $(this).find(".site-search-box").data('locale').toLowerCase() + '/s/' + $(this).find(".site-search-box").val();
        }
        return false;
    });

    $(".order-row a, .product-order-dropdown-menu a").click(function () {
        $(".order-row a").removeClass('selected').removeClass('active');
        $(".product-order-dropdown-menu a").removeClass('active').removeClass('selected');

        $(this).addClass('selected').addClass('active');

        if ($(this).hasClass("default-order")) {
            $(".product-list > div").sort(sort_li) // sort elements
                .appendTo('.product-list'); // append again to the list
            // sort function callback
        } else if ($(this).hasClass('az-order')) {
            var theList = $('.product-list');
            var theChildren = theList.children('.product-item');

            if (theList.hasClass('bundles-list')) {
                theChildren.sort(function (a, b) {
                    //console.log($(a).find('h5 a').text().toUpperCase());
                    var an = $(a).find('form h3').text().toUpperCase(),
                        bn = $(b).find('form h3').text().toUpperCase();

                    if (an > bn) {
                        return 1;
                    }
                    if (an < bn) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                theChildren.sort(function (a, b) {
                    //console.log($(a).find('h5 a').text().toUpperCase());
                    var an = $(a).find('a h5').text().toUpperCase(),
                        bn = $(b).find('a h5').text().toUpperCase();

                    if (an > bn) {
                        return 1;
                    }
                    if (an < bn) {
                        return -1;
                    }
                    return 0;
                });
            }

            theChildren.detach().appendTo(theList);



            //$(".product-list > div").sort(function (a, b) {
            //    return $(a).find('h5 a').text().toUpperCase().localeCompare($(b).find('h5 a').text().toUpperCase());
            //});
        } else if ($(this).hasClass('new-order')) {
            var theListNewOrder = $('.product-list');
            var theChildrenNewOrder = theListNewOrder.children('.product-item');

            theChildrenNewOrder.sort(function (a, b) {
                //console.log($(a).find('h5 a').text().toUpperCase());
                var an = $(a).find('a').data('new-prod'),
                    bn = $(b).find('a').data('new-prod');

                if (an > bn) {
                    return -1;
                }
                if (an < bn) {
                    return 1;
                }
                return 0;
            });

            theChildrenNewOrder.detach().appendTo(theListNewOrder);
        } else if ($(this).hasClass('za-order')) {
            var theList2 = $('.product-list');
            var theChildren2 = theList2.children('.product-item');

            if (theList2.hasClass('bundles-list')) {
                theChildren2.sort(function (a, b) {
                    //console.log($(a).find('h5 a').text().toUpperCase());
                    var an = $(a).find('form h3').text().toUpperCase(),
                        bn = $(b).find('form h3').text().toUpperCase();

                    if (an > bn) {
                        return -1;
                    }
                    if (an < bn) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                theChildren2.sort(function (a, b) {
                    //console.log($(a).find('h5 a').text().toUpperCase());
                    var an = $(a).find('a h5').text().toUpperCase(),
                        bn = $(b).find('a h5').text().toUpperCase();

                    if (an > bn) {
                        return -1;
                    }
                    if (an < bn) {
                        return 1;
                    }
                    return 0;
                });
            }

            theChildren2.detach().appendTo(theList2);
        } else if ($(this).hasClass('price-order')) {

            //$('.product-list').html(
            //    $('product-list').children('.product-item').sort(function (a, b) {
            //        return $(a).find('span:not([data-price=""])').data('price') – $(b).val();
            //    }) // End Sort
            //);

            var theList3 = $('.product-list');
            var theChildren3 = theList3.children('.product-item');
            //console.log(theChildren3.length);

            if (theList3.hasClass('bundles-list')) {
                theChildren3.sort(function (a, b) {
                    //console.log($(a).find('h5 a').text().toUpperCase());

                    //console.log(parseFloat($(a).find('span:not([data-price=""])').data('price')));

                    var an = parseFloat($(a).find('h6').data('price')),
                        bn = parseFloat($(b).find('h6').data('price'));
                    //console.log(parseFloat($(a).find('span:not([data-price=""])').length);
                    if (an > bn) {
                        return 1;
                    }
                    if (an < bn) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                theChildren3.sort(function (a, b) {
                    //console.log($(a).find('h5 a').text().toUpperCase());

                    //console.log(parseFloat($(a).find('span:not([data-price=""])').data('price')));

                    var an = parseFloat($(a).find('span:not([data-price=""])').data('price')),
                        bn = parseFloat($(b).find('span:not([data-price=""])').data('price'));
                    //console.log(parseFloat($(a).find('span:not([data-price=""])').length);
                    if (an > bn) {
                        return 1;
                    }
                    if (an < bn) {
                        return -1;
                    }
                    return 0;
                });
            }

            theChildren3.detach().appendTo(theList3);
        }

        //$(".product-list > div").each(function () {
        //    console.log($(this).data('default-counter'));
        //});
    });

    //$('#off-canvas').offcanvas({
    //    modifiers: 'left, overlay', // default options
    //    triggerButton: '.filter-list-btn' // btn to open offcanvas
    //});

    //$("#off-canvas").mmenu({
    //    "navbar": {
    //        add: false
    //    },
    //    extensions: ["fullscreen"]

    //});

    //var API = $("#off-canvas").data("mmenu");

    $(".filter-list-btn").click(function () {
        var top = $(window).scrollTop();
        //console.log(top);
        $('.filter-menu').css('left', '0');
        $('.filter-menu').css('top', top);
        var scrollPosition = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        ];
        var html = $('html');
        html.data('scroll-position', scrollPosition);
        html.data('previous-overflow', html.css('overflow'));
        html.css('overflow', 'hidden');
        window.scrollTo(scrollPosition[0], scrollPosition[1]);
        return false;
    });

    $(".filter-assets-row select").change(function () {
        var selectedAssetType = $('.filter-by-asset-type-menu').val();
        var selectedSectionType = $('.filter-by-section-menu').val();
        var selectedKnowledgeType = $('.filter-by-knowledge-menu').val();

        var assetsToShow = [];
        if (selectedAssetType > 0) {
            $(".asset-list a").each(function (index) {
                //console.log($(this).data('asset-type-id'));
                //console.log(selectedAssetType);
                if (selectedAssetType == 0) {
                    assetsToShow.push($(this).data('asset-id'));
                } else {
                    if ($(this).data('asset-type-id') == selectedAssetType) {
                        assetsToShow.push($(this).data('asset-id'));
                        //console.log($(this).data('asset-id'));
                    }
                }
            });
        } else {
            $(".asset-list a").each(function (index) {
                assetsToShow.push($(this).data('asset-id'));
            });
        }

        if (selectedSectionType > 0) {
            $(".asset-list a").each(function (index) {
                //console.log(selectedSectionType);
                if ($.inArray($(this).data('asset-id'), assetsToShow) >= 0) {
                    var AssetId = $(this).data('asset-id');
                    //console.log(AssetId);
                    //console.log("selected id:" + selectedSectionType);
                    //console.log("section ids: " + $(this).data('section-ids'));
                    var removeFromList = false;
                    if ($(this).data('section-ids') != null) {
                        //console.log($(this).data('section-ids'));
                        var array = $(this).attr('data-section-ids').split(',');
                        //console.log(array);
                        //console.log($.inArray(selectedSectionType, array));
                        if ($.inArray(selectedSectionType.toString(), array) < 0) {
                            removeFromList = true;
                        }
                    } else {
                        removeFromList = true;
                    }

                    if (removeFromList) {
                        //console.log("remove: " + AssetId);
                        assetsToShow = jQuery.grep(assetsToShow, function (value) {
                            return value != AssetId;
                        });
                    } else {
                        //console.log("keep: " + AssetId);
                    }
                }
            });
        }

        if (selectedKnowledgeType > 0) {
            $(".asset-list a").each(function (index) {
                //console.log(selectedSectionType);
                if ($.inArray($(this).data('asset-id'), assetsToShow) >= 0) {
                    var AssetId = $(this).data('asset-id');
                    //console.log(AssetId);
                    //console.log("selected id:" + selectedSectionType);
                    //console.log("section ids: " + $(this).data('section-ids'));
                    var removeFromList = false;
                    if ($(this).data('knowledgeids') != null) {
                        //console.log($(this).data('section-ids'));
                        var array = $(this).attr('data-knowledgeids').split(',');
                        //console.log(array);
                        //console.log($.inArray(selectedSectionType, array));
                        if ($.inArray(selectedKnowledgeType.toString(), array) < 0) {
                            removeFromList = true;
                        }
                    } else {
                        removeFromList = true;
                    }

                    if (removeFromList) {
                        //console.log("remove: " + AssetId);
                        assetsToShow = jQuery.grep(assetsToShow, function (value) {
                            return value != AssetId;
                        });
                    } else {
                        //console.log("keep: " + AssetId);
                    }
                }
            });
        }

        //console.log(assetsToShow);
        $(".asset-list a").each(function (index) {
            if ($.inArray($(this).data('asset-id'), assetsToShow) >= 0) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        $("html,body").trigger("scroll");

        $(this).parents('.dropdown').find('button').text($(this).text());
        $(this).parents('.dropdown-menu').removeClass('show');
        return false;
    });


    $('.close-filter-menu').click(function () {
        $('.filter-menu').css('left', '-100%');
        var html = $('html');
        var scrollPosition = html.data('scroll-position');
        html.css('overflow', html.data('previous-overflow'));
        window.scrollTo(scrollPosition[0], scrollPosition[1]);
        return false;
    });

    $('.ss-menu-link').click(function () {
        if ($('.ss-search-area').is(':visible')) {
            $('.ss-search-link').trigger('click');
        }

        if ($(this).data('status') == 'closed') {
            $(this).data('status', 'open');
            $('.ss-menu').show().animate({
                left: 0
            }, 250);
            $('.ss-menu-overlay').fadeIn(250);
            //$(this).hide();
            //$(".ss-close-link").show();
            $(this).find('.burger-menu').addClass('open');

            var scrollPosition = [
                self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
                self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            ];
            var html = $('html');
            html.data('scroll-position', scrollPosition);
            html.data('previous-overflow', html.css('overflow'));
            html.css('overflow', 'hidden');
            window.scrollTo(scrollPosition[0], scrollPosition[1]);
            //$('.ss-menu').css('overflow', 'scroll');
            $(this).find('> span').text($(this).find('> span').data('close-text'));
        } else {
            $(this).find('.burger-menu').removeClass('open');
            $(this).data('status', 'closed');
            $('.ss-menu').animate({
                left: '-100%'
            }, 250, function () {
                $(this).hide();
            });
            $('.ss-menu-overlay').fadeOut(250, function () {
                $(this).hide();
            });
            //$(this).hide();
            //$(".ss-menu-link").show();

            // un-lock scroll position
            var html2 = $('html');
            var scrollPosition2 = html2.data('scroll-position');
            html2.css('overflow', html2.data('previous-overflow'));
            window.scrollTo(scrollPosition2[0], scrollPosition2[1]);
            $(this).find('> span').text($(this).find('> span').data('menu-text'));
        }
        //console.log($(this).find('> span').length);
    });

    $(".has-children").click(function () {
        if ($(this).find('.fa-plus').is(':visible')) {
            $(this).find('.fa-plus').hide();
            $(this).find('.fa-minus').show();
            //$('.main-nav ul li ul').slideUp();
            $(this).parents('li').find('> ul').slideDown();
        } else {
            $(this).find('.fa-plus').show();
            $(this).find('.fa-minus').hide();
            $(this).siblings('ul').first().slideUp();
        }
    });

    $('#nav-icon3').click(function () {
        $(this).toggleClass('open');
    });

    //$("#oc-main-menu").mmenu({
    //    "navbar": {
    //        title: "New title"
    //    }//,
    //    //extensions: ["fullscreen"]
    //});

    //ss-menu-link
    //var MainMenuAPI = $("#oc-main-menu").data("mmenu");

    //$(".close-main-menu").click(function () {
    //    MainMenuAPI.close();
    //});


    $('.full-description-link').click(function (e) {
        e.preventDefault();
        var offset = 50;
        if ($('.ss-header').is(':visible')) {
            offset = $('.ss-header').outerHeight() + 20;
        }
        $('html, body').animate({
            scrollTop: $(".full-description-area").offset().top - offset
        }, 500);
    });

    $('.OtherProductsArea .nav-link:first').addClass('active');
    $('.OtherProductsArea .OtherProductsList').first().show();

    $(".OtherProductsArea .nav-tabs .nav-link").click(function () {
        $(".OtherProductsArea .nav-tabs .nav-link").removeClass('active');
        $(this).addClass('active');
        $('.OtherProductsList').hide();
        $('.' + $(this).data('type')).fadeIn();
    });

    $('.news-events-tabs .nav-link:first').addClass('active');
    $('.news-events-area .NewsEventsList').first().show();

    $(".news-events-tabs .nav-tabs .nav-link").click(function () {
        $(".news-events-tabs .nav-tabs .nav-link").removeClass('active');
        $(this).addClass('active');
        $('.NewsEventsList').hide();
        $('.' + $(this).data('type')).fadeIn();
        $("html,body").trigger("scroll");
        return false;
    });

    $('.colour-shade-link').popover();

    $('.colour-shade-link').on('click', function (e) {
        $('.colour-shade-link').not(this).popover('hide');
    });

    $('.wtb-tabs a').on('click', function (e) {
        $('.wtb-tabs a').removeClass('active');
        $(this).addClass('active');
        if ($(this).data('type') == "map") {
            $('.container-wrapper').show();
            $('.mobile-results-list').hide();
        } else {
            $('.container-wrapper').hide();
            $('.mobile-results-list').show();
        }
        return false;
    });

    $('.results-panel, .mobile-results-panel').on('click', '.showHideAll', function (e) {
        var lat = $(this).parents('.reseller-list-item').data('lat');
        var long = $(this).parents('.reseller-list-item').data('long');
        //console.log(lat);

        if ($(this).find('.fa-chevron-up:visible').length > 0) {
            $(this).parents('.reseller-list-item').find('.details').slideDown();
            $(this).find('.fa-chevron-down').show();
            $(this).find('.fa-chevron-up').hide();
            $('body').data('trigger-map-repopulation', false);
            map.setView({
                //mapTypeId: Microsoft.Maps.MapTypeId.aerial,
                center: new Microsoft.Maps.Location(lat, long),
                zoom: 13
                //bounds: result.bestView
            });
            $('body').data('trigger-map-repopulation', true);

        } else {
            $(this).parents('.reseller-list-item').find('.details').slideUp();
            $(this).find('.fa-chevron-down').hide();
            $(this).find('.fa-chevron-up').show();
            $('body').data('trigger-map-repopulation', false);

            map.setView({
                //mapTypeId: Microsoft.Maps.MapTypeId.aerial,
                center: new Microsoft.Maps.Location($('body').data('map-lat'), $('body').data('map-long')),
                zoom: $('body').data('map-zoom')
                //bounds: result.bestView
            });
            $('body').data('trigger-map-repopulation', true);
        }


        //$('body').data('map-lat', centreOfMap.latitude);
        //$('body').data('map-long', centreOfMap.longitude);

    });

    if ($('.examples-modal .close').length > 0) {
        $('.examples-modal').on('hide.bs.modal', function (e) {
            if ($('#example-video').length > 0) {
                var myPlayer = videojs("example-video");
                myPlayer.pause();
                $('.examples-modal .modal-body #example-video').remove();
            }
        });
    }

    $('a.widget-image[data-id-number], a.adj-image[data-id-number]').on('click', function (e) {
        $('#assetModal' + $(this).data('id-number')).modal('show');
        if ($('#video' + $(this).data('id-number')).length > 0) {
            var myPlayer = videojs('video' + $(this).data('id-number'));
            myPlayer.play();
        }
        //togglePause = function () {
        //    if (myPlayer.paused()) {
        //        myPlayer.play();
        //    }
        //    else {
        //        myPlayer.pause();
        //    }
        //}

        return false;
    });

    $('.widget-video-modal').on('hidden.bs.modal', function (e) {
        if ($(this).find('video').length > 0) {
            var videoID = $(this).find('video').attr('id');
            var myPlayer = videojs(videoID);
            myPlayer.pause();
        }
    });

    $('.show-examples-modal').on('click', function (e) {
        $('.examples-modal .modal-title').text($(this).data('title'));
        if ($(this).data('asset-type') == 2) { // image
            $('.examples-modal .modal-body img').attr('src', $(this).data('image-url')).show();
            $('.examples-modal .modal-body #example-video').remove();
        } else { // video
            $('.examples-modal .modal-body img').hide();
            var video = $('<video />').addClass('video-js').addClass('vjs-default-skin'); //.addClass('vjs-16-9');
            video.prop('controls', true);
            video.prop('autoplay', true);
            video.attr('id', 'example-video');
            video.attr('width', '100%');
            video.attr('poster', $(this).data('image-url'));
            video.attr('data-setup', '{"fluid": true}');
            var source = $('<source />').attr('src', $(this).data('filename')).attr('type', 'video/mp4');
            video.append(source);
            $('.examples-modal .modal-body #example-video').remove();
            $('.examples-modal .modal-body').append(video);

        }
        $('.examples-modal').modal({
            keyboard: false
        });
    });

    // 
    if ($('.other-images-carousel').length > 0) {
        $('.other-images-carousel').slick({
            //dots: true,
            //infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<span class="next-prev-link slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></span>',
            nextArrow: '<span class="next-prev-link slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></span>',
            //centerMode: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]

        });
    }

    if ($('.example-carousel').length > 0) {
        $('.example-carousel').slick({
            //dots: true,
            //infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: '<span class="next-prev-link slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></span>',
            nextArrow: '<span class="next-prev-link slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></span>',
            //centerMode: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        //infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]

        });
    }

    $('.sitewide-search-form .site-search-box').autoComplete({
        minChars: 2,
        menuClass: "ac-menu",
        source: function (term, response) {
            $.getJSON('/' + $(".ss-sitewide-search-form .site-search-box").data('locale') + '/acs/' + term, function (data) { response(data); });
        },
        renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            //console.log(item);
            //console.log(item.imageurl);
            //console.log(item.name);
            //console.log(item.url);
            return '<div data-val="' + search + '" data-url="' + item.url + '" data-term="' + item.name + '" class="autocomplete-suggestion"><a class="autocomplete-suggestion-link" href="' + item.url + '"><img src="' + item.imageurl + '"> ' + item.name.replace(re, "<b>$1</b>") + '</a></div>';
        },

        onSelect: function (e, term, item) {
            //alert('Item "' + item.data('langname') + ' (' + item.data('lang') + ')" selected by ' + (e.type == 'keydown' ? 'pressing enter' : 'mouse click') + '.');
            //console.log(item.data('term'));
            //console.log(item.data('url'));
            window.location = item.data('url');// '/' + $(".sitewide-search-form .site-search-box").data('locale') + '/s/' + item.text();
            return false;
            //console.log(item.text());
        }
    });

    $('.ss-sitewide-search-form .site-search-box').autoComplete({
        minChars: 2,
        menuClass: 'ss-suggestion-list',
        source: function (term, response) {
            $.getJSON('/' + $(".ss-sitewide-search-form .site-search-box").data('locale') + '/acs/' + term, function (data) { response(data); });
        },
        renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            //console.log(item);
            //console.log(item.imageurl);
            //console.log(item.name);
            //console.log(item.url);
            return '<div data-url="' + item.url + '" data-term="' + item.name + '" class="autocomplete-suggestion"><a class="autocomplete-suggestion-link" href="' + item.url + '"><img src="' + item.imageurl + '"> ' + item.name.replace(re, "<b>$1</b>") + '</a></div>';
        },
        onSelect: function (e, term, item) {
            //alert('Item "' + item.data('langname') + ' (' + item.data('lang') + ')" selected by ' + (e.type == 'keydown' ? 'pressing enter' : 'mouse click') + '.');
            //console.log(item.data('term'));
            //console.log(item.data('url'));
            window.location = item.data('url');// '/' + $(".sitewide-search-form .site-search-box").data('locale') + '/s/' + item.text();
            return false;
            //console.log(item.text());
        }
    });

    //$(".site-search-box").typeahead({
    //    source: function (query, process) {
    //        return $.getJSON(
    //            '/' + $(".site-search-box").data('locale') + '/acs/' + $(".site-search-box").val(),
    //            // { query: query },
    //            function (data) {
    //                //console.log(data);
    //                return process(data);
    //            });
    //    }//,
    //    //afterSelect: function (item) {
    //    //    // do what is needed with item
    //    //    //and then, for example ,focus on some other control
    //    //    console.log(item);

    //    //}
    //});

    //// Get the current typeahead instance
    //var typeaheadInstance = $(".site-search-box").data("typeahead");
    //// Save the reference to the original implementation of the render() function
    //var origRenderFunc = typeaheadInstance.render;

    //// Overwrite the render() function
    //typeaheadInstance.render = function () {
    //    // Execute the original implementation
    //    var result = origRenderFunc.apply(this, arguments);
    //    // Remove the 'active' class from the first item
    //    result.$menu.children().first().removeClass("active");

    //    return result;
    //};

    //$(window).resize(function () {
    //    if ($(window).width() >= 980) {

    //        // when you hover a toggle show its dropdown menu
    //        $(".navbar .dropdown-toggle").hover(function () {
    //            $(this).parent().toggleClass("show");
    //            $(this).parent().find(".dropdown-menu").toggleClass("show");
    //        });

    //        // hide the menu when the mouse leaves the dropdown
    //        $(".navbar .dropdown-menu").mouseleave(function () {
    //            $(this).removeClass("show");
    //        });

    //        // do something here
    //    }
    //});

    setCarouselHeight();

    var contentWidth = $('html').outerWidth();
    window.setInterval(function () {
        if (contentWidth != $('html').outerWidth()) {
            contentWidth = $('html').outerWidth();
            setCarouselHeight();
        }
    }, 100);
});

function sort_li(a, b) {
    return ($(b).data('default-counter')) < ($(a).data('default-counter')) ? 1 : -1;
}

function signUpComplete(data) {
    if (data != null && data.responseJSON) {
        $('.sign-up-form').hide();
        $('.signed-up-already').hide();
        $('.sign-up-thanks').fadeIn();
    } else {
        $('.sign-up-form input').prop('disabled', false);
        $('.signed-up-already').fadeIn();
    }
}
window.signUpComplete = signUpComplete;

function signUpStarted() {
    $('.sign-up-form input').prop('disabled', true);
}
window.signUpStarted = signUpStarted;


var map;

function GetMap() {
    $('body').data('trigger-map-repopulation', true);
    map = new Microsoft.Maps.Map('#myMap', {
        //center: new Microsoft.Maps.Location(39.824647, -99.524267),
        //mapTypeId: Microsoft.Maps.MapTypeId.aerial,
        //zoom: 4
        disableScrollWheelZoom: true,
        showMapTypeSelector: false
    });

    Microsoft.Maps.loadModule(['Microsoft.Maps.AutoSuggest', 'Microsoft.Maps.Search'], function () {
        var options = {
            maxResults: 4,
            map: map
        };
        var manager = new Microsoft.Maps.AutosuggestManager(options);
        manager.attachAutosuggest('#wtbSearch', '#searchBoxContainer', suggestionSelected);
        searchManager = new Microsoft.Maps.Search.SearchManager(map);
    });

    Microsoft.Maps.loadModule(['Microsoft.Maps.AutoSuggest', 'Microsoft.Maps.Search'], function () {
        var options = {
            maxResults: 4,
            map: map
        };
        var manager = new Microsoft.Maps.AutosuggestManager(options);
        manager.attachAutosuggest('#wtbSearch2', '#searchBoxContainer2', suggestionSelected);
        searchManager = new Microsoft.Maps.Search.SearchManager(map);
    });

    //map.setView({ labelOverlay: Microsoft.Maps.LabelOverlay.hidden });

    //map.setOptions({
    //});

    Microsoft.Maps.Events.addHandler(map, 'viewchangeend', function (e) {
        //var centreOfMap = map.getCenter();

        //if (centreOfMap.latitude != $('body').data('map-lat') || centreOfMap.longitude != $('body').data('map-long')) {
        if ($('body').data('trigger-map-repopulation')) {
            //console.log(e);
            reCalcPins(map);
            //}
        }
    });

    //reCalcPins(map);
    //console.log($('.wtb-page .reseller-info-box .close-link').length);
}

function suggestionSelected(result) {
    console.log(result);
    //Remove previously results from the map.
    map.entities.clear();
    //Show the suggestion as a pushpin and center map over it.
    //var pin = new Microsoft.Maps.Pushpin(result.location);
    //map.entities.push(pin);
    map.setView({ bounds: result.bestView });
    //document.getElementById('output').innerHTML = 'Selection:<br/>' + result.name;
}

function displayInfobox(e) {
    //pinInfobox.setOptions({ htmlContent: e.target.html, visible: true, offset: new Microsoft.Maps.Point(0, 20) });
    //pinInfobox.setLocation(e.target.getLocation());
    //console.log('rabbit');
    //console.log(e);
    var theDiv = $('.reseller-list-item[data-id="' + e.target.html + '"]');
    if (theDiv.find('.details:visible').length == 0) {
        theDiv.find('.details').slideDown();
        theDiv.find('.fa-chevron-down').show();
        theDiv.find('.fa-chevron-up').hide();

        $('.results-panel').animate({
            scrollTop: theDiv.position().top - 70
        }, 500);

        //console.log(theDiv.offset());
        //console.log(theDiv.position());
        //console.log($('.wtb-search-area').scrollTop());

        $('body').data('trigger-map-repopulation', false);
        map.setView({
            //mapTypeId: Microsoft.Maps.MapTypeId.aerial,
            center: new Microsoft.Maps.Location(e.location.latitude, e.location.longitude),
            zoom: 13
            //bounds: result.bestView
        });
        $('body').data('trigger-map-repopulation', true);
    } else {
        theDiv.find('.details').slideUp();
        theDiv.find('.fa-chevron-down').hide();
        theDiv.find('.fa-chevron-up').show();
        $('body').data('trigger-map-repopulation', false);
        map.setView({
            //mapTypeId: Microsoft.Maps.MapTypeId.aerial,
            center: new Microsoft.Maps.Location($('body').data('map-lat'), $('body').data('map-long')),
            zoom: $('body').data('map-zoom')
            //bounds: result.bestView
        });
        $('body').data('trigger-map-repopulation', true);
    }
}

function reCalcPins(map) {
    //console.log('hand jive');

    map.entities.push(Microsoft.Maps.TestDataGenerator.getPushpins(10, map.getBounds()));
    for (var i = map.entities.getLength() - 1; i >= 0; i--) {
        var pushpin = map.entities.get(i);
        if (pushpin instanceof Microsoft.Maps.Pushpin) {
            map.entities.removeAt(i);
        }
    }

    var mapBounds = map.getBounds();
    //console.log(mapBounds.bounds);
    var resellerData = $('.wtb-page').data('resellers');
    var pushpinInfos = [];
    var wrapperDiv = $('<div />');
    var centreOfMap = map.getCenter();
    //var centreOfMapLoc = new Microsoft.Maps.Location(centreOfMap.latitude, centreOfMap.longitude);

    $('body').data('map-zoom', map.getZoom());
    $('body').data('map-lat', centreOfMap.latitude);
    $('body').data('map-long', centreOfMap.longitude);

    var foundResellersList = [];
    var foundResellersIDList = [];

    Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {

        $.each(resellerData, function (i, item) {
            //console.log(mapBounds.bounds[0]);
            //console.log(mapBounds.bounds[2]);
            //console.log(item.Lat);
            //console.log(mapBounds.bounds[1]);
            //console.log(mapBounds.bounds[3]);
            //console.log(item.Long);

            if (item.Lat >= mapBounds.bounds[2] && item.Lat <= mapBounds.bounds[0] && item.Long >= mapBounds.bounds[3] && item.Long <= mapBounds.bounds[1]) {
                //visibleResellers.push(item);
                var resellerObj = {}; // my object
                resellerObj.lat = item.Lat;
                resellerObj.lng = item.Long;
                var resellerLoc = new Microsoft.Maps.Location(item.Lat, item.Long);
                var distanceAway = "";
                //var distanceCalc = function () {
                //Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
                //var pushpins = Microsoft.Maps.TestDataGenerator.getPushpins(2, map.getBounds());
                //map.entities.push(pushpins);
                //console.log(Microsoft.Maps.SpatialMath.getDistanceTo(resellerLoc, centreOfMap, Microsoft.Maps.SpatialMath.DistanceUnits.Miles));

                var unitName = $('.wtb-page').data('km');

                if ($('.wtb-page').data('locale').toLowerCase() == 'en-gb' || $('.wtb-page').data('locale').toLowerCase() == 'en-us') {
                    distanceAway = Math.round(Microsoft.Maps.SpatialMath.getDistanceTo(resellerLoc, centreOfMap, Microsoft.Maps.SpatialMath.DistanceUnits.Miles) * 10) / 10;
                    unitName = $('.wtb-page').data('miles');
                } else {
                    distanceAway = Math.round(Microsoft.Maps.SpatialMath.getDistanceTo(resellerLoc, centreOfMap, Microsoft.Maps.SpatialMath.DistanceUnits.Kilometers) * 10) / 10;
                }
                //console.log(Microsoft.Maps.SpatialMath.getDistanceTo(pushpins[0].getLocation(), pushpins[1].getLocation(), Microsoft.Maps.SpatialMath.DistanceUnits.Miles));

                //console.log(distanceAway);

                var resellerDiv = $('<div />').addClass('reseller-list-item').addClass('border-bottom').addClass('pb-2').addClass('pt-2').data('distance-away', distanceAway).attr('data-id', item.Id).data('lat', item.Lat).data('long', item.Long);
                var chevron = $('<a />').addClass('showHideAll').append('<i class="fa fa-chevron-up" aria-hidden="true"></i><i class="fa fa-chevron-down" aria-hidden="true"></i>');
                resellerDiv.append(chevron);

                var h6 = $('<h6 />').html(item.ResellerName + '<span>' + distanceAway + ' ' + unitName + '</span>');
                resellerDiv.append(h6);
                var detailsDiv = $('<div />').addClass('details');
                detailsDiv.append('<p>' + item.Address1 + '</p>');

                if (item.Address2 != null) {
                    detailsDiv.append('<p>' + item.Address2 + '</p>');
                }
                if (item.Address3 != null) {
                    detailsDiv.append('<p>' + item.Address3 + '</p>');
                }
                if (item.TownCity != null) {
                    detailsDiv.append('<p>' + item.TownCity + '</p>');
                }
                if (item.Postcode != null) {
                    detailsDiv.append('<p>' + item.Postcode + '</p>');
                }
                if (item.Email != null) {
                    detailsDiv.append('<p><a href="mailto:' + item.Email + '"><i class="fa fa-envelope" aria-hidden="true"></i>' + item.Email + '</a></p>');
                }
                if (item.Telephone != null) {
                    detailsDiv.append('<p><i class="fa fa-phone" aria-hidden="true"></i>' + item.Telephone + '</p>');
                }
                if (item.WebAddress != null) {
                    detailsDiv.append('<p><a rel="noopener noreferrer" target="_blank" href="' + item.WebAddress + '"><i class="fa fa-globe" aria-hidden="true"></i>' + item.WebAddress + '</a></p>');
                }
                resellerDiv.append(detailsDiv);

                var myObject = new Object();
                myObject.html = resellerDiv;
                myObject.distance = distanceAway;
                resellerObj.distance = distanceAway;

                if ($.inArray(item.Id, foundResellersIDList) >= 0) {
                    // ignore - this is a dupe
                } else {
                    foundResellersList.push(myObject);
                    foundResellersIDList.push(item.Id);
                }

                //resellerObj.html = '<div data-id="' + item.Id + '" class="reseller-info-box"><a onclick="hideInfobox();" class="close-link"><i class="fa fa-times-circle" aria-hidden="true"></i></a><h6>' + item.ResellerName + '</h6><p>' + item.Address1 + '</p>';

                //if (item.Address2 != null) {
                //    resellerObj.html += '<p>' + item.Address2 + '</p>';
                //}
                //if (item.Address3 != null) {
                //    resellerObj.html += '<p>' + item.Address3 + '</p>';
                //}
                //if (item.TownCity != null) {
                //    resellerObj.html += '<p>' + item.TownCity + '</p>';
                //}
                //if (item.Postcode != null) {
                //    resellerObj.html += '<p>' + item.Postcode + '</p>';
                //}
                //if (item.Email != null) {
                //    resellerObj.html += '<p><a href="mailto:' + item.Email + '"><i class="fa fa-envelope" aria-hidden="true"></i>' + item.Email + '</a></p>';
                //}
                //if (item.Telephone != null) {
                //    resellerObj.html += '<p><i class="fa fa-phone" aria-hidden="true"></i>' + item.Telephone + '</p>';
                //}
                //if (item.WebAddress != null) {
                //    resellerObj.html += '<p><a rel="noopener noreferrer" target="_blank" href="' + item.WebAddress + '"><i class="fa fa-globe" aria-hidden="true"></i>' + item.WebAddress + '</a></p>';
                //}

                //resellerObj.html += '</div >';
                resellerObj.html = item.Id;

                pushpinInfos.push(resellerObj);

                //});
                //};

                //console.log(item.Lat);
                //console.log(item.Long);

            }


        });


        //var sortByProperty = function (property) {

        //    return function (x, y) {

        //        return ((x[property] === y[property]) ? 0 : ((x[property] > y[property]) ? 1 : -1));

        //    };

        //};

        foundResellersList.sort(function (obj1, obj2) {
            // Ascending: first age less than the previous
            //console.log(obj1.distance);
            //console.log(obj2.distance);
            return obj1.distance - obj2.distance;
        });

        pushpinInfos.sort(function (obj1, obj2) {
            // Ascending: first age less than the previous
            //console.log(obj1.distance);
            //console.log(obj2.distance);
            return obj1.distance - obj2.distance;
        });

        //console.log(foundResellersList);

        var loopNumber = 1;
        $.each(foundResellersList, function (key, value) {
            //console.log(key + ": " + value.distance);
            var allHTML = value.html;
            var lineNumber = $('<strong />').text(loopNumber);
            //console.log(loopNumber);
            //console.log(allHTML.find('h6').text());
            allHTML.find('h6').prepend(lineNumber);
            wrapperDiv.append(allHTML);
            loopNumber++;
        });

        $('.mobile-results-panel').html('').append(wrapperDiv.clone());
        $('.results-panel').html('').append(wrapperDiv);

        //console.log("Sdfsdfsd");
        //var list2 = foundResellersList.sort(function (obj1, obj2) {
        //    // Ascending: first age less than the previous
        //    console.log(obj1.distance);
        //    console.log(obj2.distance);
        //    return obj1.distance - obj2.distance;
        //});
        //console.log(list2);
        //console.log(resellerData);
        //console.log(pushpinInfos);

        //Add your post map load code here.
        var infoboxLayer = new Microsoft.Maps.EntityCollection();
        var pinLayer = new Microsoft.Maps.EntityCollection();

        // Create the info box for the pushpin
        //pinInfobox = new Microsoft.Maps.Infobox(new Microsoft.Maps.Location(0, 0), { visible: false });
        //infoboxLayer.push(pinInfobox);
        //console.log("sdfsdfsdfsd");

        var redColor = $('.breadcrumb-item:first a').css('color');
        //console.log(redColor);
        //var fontFamily = $('.wtb-search-form button').css('font-family');

        var locs = [];
        loopNumber = 1;
        //console.log(pushpinInfos.length);
        for (var y = 0; y < pushpinInfos.length; y++) {

            locs[y] = new Microsoft.Maps.Location(pushpinInfos[y].lat, pushpinInfos[y].lng);
            var pin = new Microsoft.Maps.Pushpin(locs[y], {
                //pin.Title = pushpinInfos[y].title + 'fsdfsdfs';
                //pin.Description = pushpinInfos[y].description;
                //icon: 'https://www.bingmapsportal.com/Content/images/poi_custom.png',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"><circle cx="15" cy="15" r="13" stroke="black" stroke-width="2" fill="' + redColor + '"/><text font-family="arial" fill="white" x="15" y="20" text-anchor="middle">' + loopNumber + '</text></svg>',
                anchor: new Microsoft.Maps.Point(20, 20)
            }
            );
            pin.html = pushpinInfos[y].html;

            //pin.icon = 'https://www.bingmapsportal.com/Content/images/poi_custom.png';
            //pin.icon = c.toDataURL();
            //pin.anchor = new Microsoft.Maps.Point(c.width / 2, c.height / 2); //Align center of pushpin with location.

            pinLayer.push(pin);
            //console.log(pin);
            Microsoft.Maps.Events.addHandler(pin, 'click', displayInfobox);
            loopNumber++;
        }

        map.entities.push(pinLayer);
        map.entities.push(infoboxLayer);


        //var center = map.getCenter();
        //var infobox = new Microsoft.Maps.Infobox(center, {
        //    title: 'Map Center',
        //    description: 'Seattle'
        //});
        //pinInfobox.setMap(map);
        //Microsoft.Maps.Events.addHandler(pinInfobox, 'click', whatIsThis(this));
    });
}

function sortByKeyAsc(array, key) {
    return array.sort(function (a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

function SortByDistance(a, b) {
    var aName = a.distance;
    var bName = b.distance;
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
}

function hideInfobox(e) {
    pinInfobox.setOptions({ visible: false });
}
window.hideInfobox = hideInfobox;

function geocode() {
    //Remove previously results from the map.
    map.entities.clear();
    //Get the users query and geocode it.
    var query = document.getElementById('wtb-search').value;
    var searchRequest = {
        where: query,
        callback: function (r) {
            if (r && r.results && r.results.length > 0) {
                var pin, pins = [], locs = [], output = 'Results:<br/>';
                //Add a pushpin for each result to the map and create a list to display.
                for (var i = 0; i < r.results.length; i++) {
                    //Create a pushpin for each result.
                    pin = new Microsoft.Maps.Pushpin(r.results[i].location, {
                        text: i + ''
                    });
                    pins.push(pin);
                    locs.push(r.results[i].location);
                    output += i + ') ' + r.results[i].name + '<br/>';
                }
                //Add the pins to the map
                map.entities.push(pins);
                //Display list of results
                document.getElementById('output').innerHTML = output;
                //Determine a bounding box to best view the results.
                var bounds;
                if (r.results.length == 1) {
                    bounds = r.results[0].bestView;
                } else {
                    //Use the locations from the results to calculate a bounding box.
                    bounds = Microsoft.Maps.LocationRect.fromLocations(locs);
                }
                map.setView({ bounds: bounds, padding: 30 });
            }
        },
        errorCallback: function (e) {
            document.getElementById('output').innerHTML = "No results found.";
        }
    };
    //Make the geocode request.
    searchManager.geocode(searchRequest);
}
window.geocode = geocode;

function forgottenPasswordEnd(data) {
    //console.log(data);
    if (data.responseJSON) {
        $('.forgotten-password-form-area').hide();
        $('.forgotten-password-thanks-area').fadeIn();
    } else {
        $('.details-not-found').fadeIn();
    }
}
window.forgottenPasswordEnd = forgottenPasswordEnd;

function setCarouselHeight() {
    $('.carousel').each(function () {
        var height = 0;
        var items = $(this).find('.carousel-item');

        items.css('height', '').addClass('d-none h-100');
        items.each(function () {
            height = Math.max(height, $(this).actual('height'));
        });
        items.removeClass('d-none h-100').css('height', height + 'px');
    });
}

function ContactUsForm(data) {
    $('.contact-us-form').hide();
    $('.thanks-area').removeClass('d-none');
}

window.ContactUsForm = ContactUsForm;

function validateRecaptcha() {
    if (grecaptcha !== null) {
        var response = grecaptcha.getResponse();
        if (response.length === 0) {
            //alert("not validated");
            $('.pleaseSayYouAreNotARobot').removeClass('d-none');

            return false;
        } else {
            //alert("validated");
            $('.pleaseSayYouAreNotARobot').addClass('d-none');

            return true;
        }
    } else {
        //alert("not found");
        return false;
    }
}
window.validateRecaptcha = validateRecaptcha;

function ConsumerCatalogueForm(data) {
    $('.consumer-catalogue-form').addClass('d-none');
    $('.thanks-area').removeClass('d-none');
}

window.ConsumerCatalogueForm = ConsumerCatalogueForm;

function USSamplingForm(data) {
    //status
    //console.log(data);
    try {
        window.addEventListener('marketingCookiesAccepted', function (e) {
            if (typeof fbq !== 'undefined') {
                fbq('track', 'CompleteRegistration');
            }
        }, false);
    }
    catch (err) {
        //Block of code to handle errors
    }

    if (data.responseJSON.status) {
        $('.existing-subscriber').removeClass('d-none');
    } else {
        $('.new-subscriber').removeClass('d-none');
    }
    $('.us-sampling-form').addClass('d-none');
    $('.us-thanks-area').removeClass('d-none');
}

window.USSamplingForm = USSamplingForm;

function ListBuildingComplete(data) {
    //console.log(data);
    //console.log(data.responseJSON);
    $('.list-building-modal-form').addClass('d-none');
    if (data.responseJSON) {
        $('.list-building-thanks-area').removeClass('d-none');
    } else {
        $('.list-building-already-signed-up-area').removeClass('d-none');
    }
}

window.ListBuildingComplete = ListBuildingComplete;

function WishListEmailStart() {
    $('.send-list-button').prop('disabled', true).html('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i>' + $('.send-list-button').data('sending'));
}
window.WishListEmailStart = WishListEmailStart;

function WishListEmailEnd() {
    $('.send-list-button').prop('disabled', false).text($('.send-list-button').data('sendlist'));
    var emailAddress = $('#RecipientEmail').val();
    $('.wish-list-sent .alert').text($('.wish-list-sent').data('text').replace('{email}', emailAddress));
    $('.wish-list-sent').removeClass('d-none');
}
window.WishListEmailEnd = WishListEmailEnd;

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
!function (e, n, A) { function o(e) { var n = u.className, A = Modernizr._config.classPrefix || ""; if (c && (n = n.baseVal), Modernizr._config.enableJSClass) { var o = new RegExp("(^|\\s)" + A + "no-js(\\s|$)"); n = n.replace(o, "$1" + A + "js$2") } Modernizr._config.enableClasses && (n += " " + A + e.join(" " + A), c ? u.className.baseVal = n : u.className = n) } function t(e, n) { return typeof e === n } function a() { var e, n, A, o, a, i, l; for (var f in r) if (r.hasOwnProperty(f)) { if (e = [], n = r[f], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (A = 0; A < n.options.aliases.length; A++)e.push(n.options.aliases[A].toLowerCase()); for (o = t(n.fn, "function") ? n.fn() : n.fn, a = 0; a < e.length; a++)i = e[a], l = i.split("."), 1 === l.length ? Modernizr[l[0]] = o : (!Modernizr[l[0]] || Modernizr[l[0]] instanceof Boolean || (Modernizr[l[0]] = new Boolean(Modernizr[l[0]])), Modernizr[l[0]][l[1]] = o), s.push((o ? "" : "no-") + l.join("-")) } } function i(e, n) { if ("object" == typeof e) for (var A in e) f(e, A) && i(A, e[A]); else { e = e.toLowerCase(); var t = e.split("."), a = Modernizr[t[0]]; if (2 == t.length && (a = a[t[1]]), "undefined" != typeof a) return Modernizr; n = "function" == typeof n ? n() : n, 1 == t.length ? Modernizr[t[0]] = n : (!Modernizr[t[0]] || Modernizr[t[0]] instanceof Boolean || (Modernizr[t[0]] = new Boolean(Modernizr[t[0]])), Modernizr[t[0]][t[1]] = n), o([(n && 0 != n ? "" : "no-") + t.join("-")]), Modernizr._trigger(e, n) } return Modernizr } var s = [], r = [], l = { _version: "3.6.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function (e, n) { var A = this; setTimeout(function () { n(A[e]) }, 0) }, addTest: function (e, n, A) { r.push({ name: e, fn: n, options: A }) }, addAsyncTest: function (e) { r.push({ name: null, fn: e }) } }, Modernizr = function () { }; Modernizr.prototype = l, Modernizr = new Modernizr; var f, u = n.documentElement, c = "svg" === u.nodeName.toLowerCase(); !function () { var e = {}.hasOwnProperty; f = t(e, "undefined") || t(e.call, "undefined") ? function (e, n) { return n in e && t(e.constructor.prototype[n], "undefined") } : function (n, A) { return e.call(n, A) } }(), l._l = {}, l.on = function (e, n) { this._l[e] || (this._l[e] = []), this._l[e].push(n), Modernizr.hasOwnProperty(e) && setTimeout(function () { Modernizr._trigger(e, Modernizr[e]) }, 0) }, l._trigger = function (e, n) { if (this._l[e]) { var A = this._l[e]; setTimeout(function () { var e, o; for (e = 0; e < A.length; e++)(o = A[e])(n) }, 0), delete this._l[e] } }, Modernizr._q.push(function () { l.addTest = i }), Modernizr.addAsyncTest(function () { function e(e, n, A) { function o(n) { var o = n && "load" === n.type ? 1 == t.width : !1, a = "webp" === e; i(e, a && o ? new Boolean(o) : o), A && A(n) } var t = new Image; t.onerror = o, t.onload = o, t.src = n } var n = [{ uri: "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=", name: "webp" }, { uri: "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==", name: "webp.alpha" }, { uri: "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA", name: "webp.animation" }, { uri: "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=", name: "webp.lossless" }], A = n.shift(); e(A.name, A.uri, function (A) { if (A && "load" === A.type) for (var o = 0; o < n.length; o++)e(n[o].name, n[o].uri) }) }), a(), o(s), delete l.addTest, delete l.addAsyncTest; for (var p = 0; p < Modernizr._q.length; p++)Modernizr._q[p](); e.Modernizr = Modernizr }(window, document);